export default "__VITE_ASSET__DfIEXhM$__"